module.exports = __webpack_public_path__ + "img/artemis.a079dd1d.png";